import DOMPurify from "dompurify";

/**
 * xss
 */
export function filterXSS(input: string) {
    return DOMPurify.sanitize(input, {
        USE_PROFILES: { html: true },
        ADD_ATTR: ['fixed'],
    });
}